// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1!i,e:_!3p1f@2_FnV7-!9_mV%_,@(>98>YtL><m<p<fo6J-J(b,o,Kfz!QmXV+azIQS((Lm%7e!%V<VdeQ+8,1m$(L+_!otb(JSFS>9[(n-v(+X49i)nZ7Fy,Q:17HdG,QtXSRrn%LS437z4Sj,JIQRE9btyIy+E(bSZIH<y%bee(bV8:<QmkpR)6<X<2b-E9j!FSKX-IRQB%%!:Sj@G9KXB6g-FpQ!F>%X<2p@6p<-)!jyQaNRQpg!F6<4$27y@G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@FpbX;2bR@9Qd@I_@:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll';
